
export const CHECK_SLIDERPAGE = 'CHECK_SLIDERPAGE';
export const CHECK_CORONADIALOG = 'CHECK_CORONADIALOG';
